import React, { Component } from "react";

export default class ClickOutSilde extends Component {
  static defaultProps = {
    onClickOutSide: () => null
  };
  componentDidMount = () => {
    document.addEventListener('mousedown', this.handleClickOutSide);
  }
  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClickOutSide);
  }
  handleClickOutSide = (e) => {
    if (this.block && !this.block.contains(e.target)) {
      this.props.onClickOutSide(true);
    }
  }
  render() {
    const { className, children } = this.props;
    return (
      <div className={className} ref={e => (this.block = e)}>
        {children}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ClickOutSilde.js